(function () {
  var STORAGE_KEY = "maddox_enquiry_customer";

  var FIELDS = [
    { key: "first_name", selector: 'input[autocomplete="given-name"]' },
    { key: "last_name", selector: 'input[autocomplete="family-name"]' },
    { key: "email", selector: 'input[type="email"][name="email"]' },
    { key: "phone", selector: 'input[type="tel"][name="phone-number"]' },
    { key: "address", selector: 'input[autocomplete="address-line1"]' },
    { key: "postcode", selector: 'input[autocomplete="postal-code"]' },
    { key: "message", selector: 'textarea, input[name*="message" i], textarea[name*="message" i]' },
  ];

  function storageAvailable() {
    try {
      var test = "__maddox_storage_test__";
      sessionStorage.setItem(test, test);
      sessionStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }

  function loadStored() {
    if (!storageAvailable()) return null;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function saveStored(partial) {
    if (!storageAvailable() || !partial) return;
    try {
      var existing = loadStored() || {};
      Object.keys(partial).forEach(function (key) {
        if (partial[key]) existing[key] = partial[key];
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch (error) {}
  }

  function setReactValue(input, value) {
    var descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    );
    if (!descriptor || !descriptor.set) {
      input.value = value;
    } else {
      descriptor.set.call(input, value);
    }
    ["input", "change", "blur"].forEach(function (eventName) {
      input.dispatchEvent(new Event(eventName, { bubbles: true }));
    });
  }

  function getEnquiryModal(scope) {
    scope = scope || document;
    return (
      scope.querySelector(
        '[data-modal] .modal__content [data-product-enquiry-modal]'
      ) ||
      scope.querySelector(
        '[data-product-enquiry-modal][data-modal-portal-active="true"]'
      )
    );
  }

  function getKlaviyoForm(modal) {
    if (!modal) return null;
    return (
      modal.querySelector('form[data-testid^="klaviyo-form-"]') ||
      modal.querySelector('[class*="klaviyo-form-"] form')
    );
  }

  function fieldFromInput(input) {
    for (var i = 0; i < FIELDS.length; i++) {
      if (input.matches(FIELDS[i].selector)) return FIELDS[i];
    }
    return null;
  }

  function rehydrateCustomerFields(scope) {
    var modal = getEnquiryModal(scope);
    var form = getKlaviyoForm(modal);
    var stored = loadStored();
    if (!form || !stored) return;
    FIELDS.forEach(function (field) {
      if (!stored[field.key]) return;
      var input = form.querySelector(field.selector);
      if (input && !input.value) setReactValue(input, stored[field.key]);
    });
  }

  var lastKlaviyoMeta = null;

  function saveFromKlaviyoMeta(meta) {
    if (!meta) return;
    lastKlaviyoMeta = meta;
    var partial = {};
    if (meta.email) partial.email = meta.email;
    if (meta.phone_number) partial.phone = meta.phone_number;
    if (meta["First Name"]) partial.first_name = meta["First Name"];
    if (meta["Last Name"]) partial.last_name = meta["Last Name"];
    if (meta.Address) partial.address = meta.Address;
    if (meta["Postcode / ZIP Code"]) partial.postcode = meta["Postcode / ZIP Code"];
    saveStored(partial);
  }

  function scheduleRehydrate() {
    [0, 50, 150, 300, 600].forEach(function (delay) {
      window.setTimeout(function () {
        rehydrateCustomerFields(document);
      }, delay);
    });
  }

  function resolveFormId(modalEl) {
    var idMap = window.__maddoxEnquiryFormId || {};

    if (modalEl && modalEl.dataset && modalEl.dataset.klaviyoFormId) {
      return modalEl.dataset.klaviyoFormId;
    }

    if (modalEl && modalEl.id && idMap[modalEl.id]) return idMap[modalEl.id];

    var keys = Object.keys(idMap);
    if (keys.length === 1) return idMap[keys[0]];

    var container = modalEl && (
      modalEl.querySelector('[class*="klaviyo-form-"]') ||
      modalEl.closest('[class*="klaviyo-form-"]')
    );
    if (container) {
      var m = container.className.match(/klaviyo-form-([A-Za-z0-9]{4,8})/);
      if (m && m[1]) return m[1];
    }

    return '';
  }

  function collectFormFields(form) {
    var data = {};
    if (!form) return data;
    var stored = loadStored() || {};
    FIELDS.forEach(function (field) {
      var input = form.querySelector(field.selector);
      var value = (input && input.value && input.value.trim()) || stored[field.key] || '';
      if (value) data[field.key] = value;
    });
    return data;
  }

  function dispatchMaddoxEnquiry(formId, fields) {
    if (!formId) return;
    if (typeof window.MADDOX_TRACK_CONFIRMED_LEAD !== 'function') return;
    var ctx = window.MADDOX_PAGE_CONTEXT || {};
    window.MADDOX_TRACK_CONFIRMED_LEAD('artwork_enquiry_submitted', {
      form_id: formId,
      email: fields.email || '',
      first_name: fields.first_name || '',
      last_name: fields.last_name || '',
      phone: fields.phone || '',
      message: fields.message || '',
      artwork_id: ctx.artwork_id || '',
      artwork_title: ctx.artwork_title || '',
      artwork_sku: ctx.artwork_sku || '',
      artist_name: ctx.artist_name || '',
      artist_id: ctx.artist_id || '',
      artist_slug: ctx.artist_slug || '',
      shopify_product_id: ctx.shopify_product_id || '',
      shopify_variant_id: ctx.shopify_variant_id || '',
      product_url: ctx.product_url || '',
      price: ctx.price || '',
      price_band: ctx.price_band || '',
      price_visibility: ctx.price_visibility || '',
      medium: ctx.medium || '',
      dimensions: ctx.dimensions || '',
      year: ctx.year || '',
      edition_or_series: ctx.edition_or_series || '',
      availability: ctx.availability || '',
      collection_name: ctx.collection_name || '',
      event_source: 'enquiry_modal_success'
    });
  }

  document.addEventListener(
    "input",
    function (event) {
      var input = event.target;
      if (!input || !input.matches("input, textarea")) return;
      var form = input.closest('form[data-testid^="klaviyo-form-"]');
      if (!form || !form.closest("[data-product-enquiry-modal]")) return;
      var field = fieldFromInput(input);
      var value = input.value ? input.value.trim() : "";
      if (!field || !value) return;
      var partial = {};
      partial[field.key] = value;
      saveStored(partial);
    },
    true
  );

  document.addEventListener("enquiry-modal:ready", scheduleRehydrate);

  window.addEventListener("klaviyoForms", function (event) {
    if (!event.detail) return;

    if (event.detail.type === "embedOpen") {
      scheduleRehydrate();
      return;
    }

    if (
      event.detail.type === "submit" ||
      event.detail.type === "stepSubmit"
    ) {
      saveFromKlaviyoMeta(event.detail.metaData);
    }

  });

  document.addEventListener("DOMContentLoaded", function () {
    scheduleRehydrate();
  });

  document.addEventListener("shopify:section:load", scheduleRehydrate);

  window.__maddoxKlaviyoListenerLoaded = true;
})();
